export const getWalkthroughResumePath = (data) => {
  if (!data?.eligible || data?.waiting_for_terms || data?.completed) {
    return null
  }

  const state = data.state || {}
  const practiceClientId = data.practice_client_id
  const programId = data.latest_program_id
  const programClientId = data.latest_program_client_id || practiceClientId

  if (!state.program_created) {
    return practiceClientId ? `/client/${practiceClientId}` : "/clients"
  }

  if (!state.program_published) {
    if (programId && programClientId) {
      return `/program/edit/${programClientId}/${programId}`
    }

    return practiceClientId
      ? `/program/add/${practiceClientId}`
      : "/clients"
  }

  return programId ? `/program/${programId}` : "/clients"
}
